import React, {Component} from 'react';
import { extend } from 'lodash';
import ProductBadges from './ProductListItems/ProductBadges';
import ProductCategory from './ProductListItems/ProductCategory';
import ProductCertification from './ProductListItems/ProductCertification';
import ProductInfo from './ProductListItems/ProductInfo';
import ProductManufacturer from './ProductListItems/ProductManufacturer';
import ProductRating from './ProductListItems/ProductRating';
import ProductReviewCount from './ProductListItems/ProductReviewCount';
import './product_search';

class ProductListItem extends Component {
  constructor(props) {
    super();
  }

  render (){
    const {bemBlocks, result} = this.props;
    let url = '/products/' + result._source.slug;
    const source:any = extend({}, result._source, result.highlight);

    const ifBadgesExists = result._source.badges_urls.length >= 1,
          ifCategoryExists = result._source.category,
          ifSubCategoryExists = result._source.subcategory,
          ifCertificationExists = result._source.certification_url,
          ifManufacturerExists = result._source.manufacturer,
          ifReviewExists = result._source.reviews_count >= 1;

    return (
      <a href={url} className={bemBlocks.item().mix(bemBlocks.container('item'))} data-qa='hit'>
        <div className={bemBlocks.item('poster')}>
          <img alt='presentation' data-qa='poster' src={result._source.photo_url} />
          { ifReviewExists &&
            <ProductReviewCount {...result} />
          }
        </div>
        <div className={bemBlocks.item('details')}>
          <ProductInfo {...result} />
          <div>
            { ifCategoryExists &&
              <ProductCategory {...result} />
            }
            { ifManufacturerExists &&
              <ProductManufacturer {...result} />
            }
          </div>
          { ifBadgesExists &&
            <ProductBadges {...result} />
          }
        </div>
        <div className={bemBlocks.item('mid-column')}>
          { ifCertificationExists &&
            <ProductCertification {...result}/>
          }
        </div>
        <ProductRating {...result} />
      </a>
    )
  }
}

export default ProductListItem;



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/product_list_item.jsx